if (!customElements.get('ee-freight-calculator')) {
  customElements.define('ee-freight-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const delivery = this.closest('product-info')?.querySelector('details[id*="Details-delivery_pickup-"] .accordion-details__content');
      if (!delivery) return;
      delivery.append(this); this.hidden = false;
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-freight-status]');
      this.rates = this.querySelector('[data-freight-rates]');
      this.button = this.form.querySelector('button');
      this.messages = JSON.parse(this.querySelector('[data-freight-messages]').textContent);
      this.root = this.dataset.root.replace(/\/?$/, '/');
      this.form.addEventListener('submit', event => { event.preventDefault(); this.calculate(); });
      this.form.addEventListener('input', event => { if(event.target.name==='postcode'){this.form.elements.state.value='';this.querySelector('[data-freight-state]').hidden=true;} this.invalidate(); });
      if (window.FoxTheme?.pubsub) this.unsubscribe = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => this.invalidate());
    }
    disconnectedCallback() { this.controller?.abort(); this.unsubscribe?.(); }
    invalidate() {
      this.controller?.abort();
      if (this.rates.children.length || this.busy) this.status.textContent = this.messages.changed;
      this.rates.replaceChildren(); this.busy = false; this.button.disabled = false;
    }
    fingerprint(cart) { return JSON.stringify(cart.items.map(item => [item.key, item.quantity])); }
    async request(path, signal, method = 'GET') {
      const response = await fetch(this.root + path, { method, signal, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Shipping request failed');
      return response.json();
    }
    async calculate() {
      this.controller?.abort();
      const controller = new AbortController(); this.controller = controller;
      const signal = controller.signal;
      this.rates.replaceChildren(); this.busy = true; this.button.disabled = true; this.status.textContent = this.messages.loading;
      try {
        const cart = await this.request('cart.js', signal);
        if (!cart.item_count) { this.status.textContent = this.messages.empty; return; }
        const fingerprint = this.fingerprint(cart);
        const fields = new FormData(this.form);
        if (!this.postcodes) { const response = await fetch(this.dataset.postcodes, { signal }); if (!response.ok) throw new Error('Postcode lookup unavailable'); this.postcodes = await response.json(); }
        const states = { VIC:'Victoria', NSW:'New South Wales', QLD:'Queensland', ACT:'Australian Capital Territory', SA:'South Australia', WA:'Western Australia', TAS:'Tasmania', NT:'Northern Territory' };
        const postcode = String(fields.get('postcode')).trim();
        const state = fields.get('state') || states[this.postcodes[postcode]];
        if (!state) { this.querySelector('[data-freight-state]').hidden=false; this.status.textContent=this.messages.confirmState; return; }
        const params = new URLSearchParams({ 'shipping_address[zip]': postcode, 'shipping_address[country]': 'Australia', 'shipping_address[province]': state });
        await this.request('cart/prepare_shipping_rates.json?' + params, signal, 'POST');
        let result = null;
        for (let attempt = 0; attempt < 25; attempt++) {
          if (signal.aborted) return;
          result = await this.request('cart/async_shipping_rates.json?' + params, signal);
          if (result !== null) break;
          await new Promise(resolve => setTimeout(resolve, 1500));
        }
        if (signal.aborted) return;
        if (result === null) throw new Error('Shipping calculation timed out');
        const currentCart = await this.request('cart.js', signal);
        if (this.fingerprint(currentCart) !== fingerprint) { this.status.textContent = this.messages.changed; return; }
        const rates = (result.shipping_rates || []).filter(rate => Number.isFinite(Number(rate.price)));
        if (!rates.length) { this.status.textContent = this.messages.none; return; }
        this.status.textContent = this.messages.ready;
        rates.forEach(rate => {
          const item = document.createElement('li');
          const price = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: rate.currency || cart.currency || 'AUD' }).format(Number(rate.price));
          const name = document.createElement('span'); name.textContent = rate.presentment_name || rate.name; const amount = document.createElement('strong'); amount.textContent = price; item.append(name, amount); this.rates.append(item);
        });
      } catch (error) {
        if (!signal.aborted) this.status.textContent = this.messages.failed;
      } finally {
        if (this.controller === controller) { this.busy = false; this.button.disabled = false; }
      }
    }
  });
}
